export default __webpack_public_path__ + "c30bac2.png";